{
    "events__form_create_title": "Neuer Termin",
    "events__form_title_placeholder": "Titel hinzufügen",
    "events__form_agenda_placeholder": "Agenda (wird mit Teilnehmern geteilt)",
    "events__card_default_title": "Kundenbesuch",
    "events__form_edit_title": "Termin bearbeiten",
    "events__form_customer_placeholder": "Kunde auswählen (optional)",
    "events__form_location_placeholder": "Adresse eingeben",
    "events__form_location_use_custom_address": "\"{{address}}\" verwenden",
    "events__form_address_type_bill_to": "Rechnung",
    "events__form_address_type_ship_to": "Versand",
    "events__form_address_type_primary": "Primär",
    "events__form_regular_event_label": "Regelmäßiger Termin",
    "events__form_created_by": "Erstellt von {{ownerName}}",
    "events__form_create_toast__success_title": "Termin erfolgreich erstellt",
    "page_header__new_event": "Termin",
    "card_tasks_open_one": "{{count}} offen",
    "card_tasks_open_other": "{{count}} offen",
    "card_tasks_overdue_one": "{{count}} überfällig",
    "card_tasks_overdue_other": "{{count}} überfällig",
    "card_time_format": "{{startTime}} – {{endTime}}",
    "card_log_button": "Protokollieren",
    "card_log_button_logged": "Protokolliert",
    "card_protocol_attachments_one": "{{count}} Anhang",
    "card_protocol_attachments_other": "{{count}} Anhänge",
    "card_protocol_tasks_one": "{{count}} Aufgabe",
    "card_protocol_tasks_other": "{{count}} Aufgaben",
    "card_protocol_offers_one": "{{count}} Angebot",
    "card_protocol_offers_other": "{{count}} Angebote",
    "card_protocol_insights_triaged_one": "{{count}} Insight triagiert",
    "card_protocol_insights_triaged_other": "{{count}} Insights triagiert",
    "card_protocol_open": "{{type}} öffnen",
    "card_protocol__no_customer_hint": "Zum Protokollieren muss ein Kunde mit dem Termin verknüpft sein",
    "events__form_time_start_placeholder": "Startzeit",
    "events__form_time_end_placeholder": "Endzeit",
    "events__form_time_end_before_start": "Die Endzeit darf nicht vor der Startzeit liegen.",
    "card_recurrence_weeks_one": "Jede Woche",
    "card_recurrence_weeks_other": "Alle {{count}} Wochen",
    "events__form_date_label": "Datum",
    "events__form_recurrence_repeat_every": "Wiederholen alle",
    "events__form_recurrence_weeks": "Wochen",
    "events__form_recurrence_on": "Am",
    "events__form_recurrence_until_label": "Bis",
    "event": "Termin",
    "events__close": "Schließen",
    "events__edit": "Bearbeiten",
    "events__delete": "Löschen",
    "events__delete_success": "Termin gelöscht",
    "events__delete_error": "Fehler beim Löschen des Termins",
    "events__delete_confirmation__body": "Diese Aktion kann nicht rückgängig gemacht werden. Bereits festgehaltene Notizen zu Terminen bleiben erhalten.",
    "events__delete__title": "Termin löschen?",
    "events__recurrence_scope__title": "Terminserie bearbeiten",
    "events__recurrence_scope__body": "Was soll aktualisiert werden?",
    "events__recurrence_scope__single": "Nur dieser Termin",
    "events__recurrence_scope__following": "Dieser und alle folgenden Termine",
    "events__recurrence_scope__confirm": "Speichern",
    "events__drag_scope__title": "Terminserie verschieben",
    "events__drag_scope__body": "Was soll aktualisiert werden?",
    "events__drag_scope__single": "Nur dieser Termin",
    "events__drag_scope__update_schedule": "Wiederholungsplan aktualisieren",
    "events__drag_scope__confirm": "Speichern",
    "period__day": "Tag",
    "period__week": "Woche",
    "calendar_week_abbr": "KW",
    "today": "Heute",
    "today_day_number_ordinal_other": "{{count}}.",
    "foreign_calendar": "Fremder Kalender",
    "maps": "Maps",
    "calendar_nav__previous_day": "Vorheriger Tag",
    "calendar_nav__next_day": "Nächster Tag",
    "calendar_nav__previous_week": "Vorherige Woche",
    "calendar_nav__next_week": "Nächste Woche",
    "calendar_day_suggestions_label": "Vorgeschlagene Besuche",
    "calendar_day_suggestions_show_more": "Mehr anzeigen",
    "calendar_day_suggestions_show_less": "Weniger anzeigen",
    "calendar_day_suggestions_empty": "Keine",
    "recommended_customers_tier_a": "Auf deiner Route",
    "recommended_customers_tier_b": "Nähere Umgebung",
    "recommended_customers_tier_c": "Im weiteren Umkreis",
    "suggestion_feedback__title": "Was stimmt nicht mit dieser Empfehlung?",
    "suggestion_feedback__reason_set_inactive": "Kunde inaktiv setzen",
    "suggestion_feedback__reason_set_inactive_hint": "Blendet den Kunden überall in Plato aus, nicht nur hier.",
    "suggestion_feedback__reason_never_visited": "Dieser Kunde wird nie besucht",
    "suggestion_feedback__reason_too_frequent": "Dieser Kunde wird zu häufig vorgeschlagen",
    "suggestion_feedback__frequency_label": "Wie oft möchtest du diesen Kunden sehen?",
    "suggestion_feedback__frequency_weeks": "Alle {{weeks}} Wochen",
    "suggestion_feedback__submit": "Empfehlung ausblenden",
    "suggestion_feedback__submit_inactive": "Kunde inaktiv setzen",
    "suggestion_feedback__toast_hidden": "Vorschlag ausgeblendet",
    "suggestion_feedback__toast_inactive": "Kunde wurde inaktiv gesetzt",
    "suggestion_feedback__inactive_reason": "Über Empfehlungs-Feedback als inaktiv markiert",
    "suggestion_feedback__error": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
    "viewing_banner_text": "Du siehst die Termine von <strong>{{name}}</strong>",
    "viewing_banner_back": "Zurück zu meinen Terminen",
    "open_route_in_maps": "Route in Maps öffnen",
    "events__form_attendees_placeholder": "Teilnehmer hinzufügen",
    "events__form_attendees_invalid_email": "Bitte eine gültige E-Mail-Adresse eingeben",
    "events__form_attendees_no_email": "Keine E-Mail-Adresse",
    "fake_door_next_event_button": "Nächsten Besuch planen",
    "fake_door_next_event_toast_title": "Demnächst verfügbar",
    "fake_door_next_event_toast_description": "Wir arbeiten daran, dass du den nächsten Besuch direkt von hier aus planen kannst.",
    "aria__schedule_event": "Termin planen",
    "aria__dismiss_suggestion": "Vorschlag ausblenden"
}
